import { render, staticRenderFns } from "./FieldBoolTranslator.vue?vue&type=template&id=0b8fb98c&"
import script from "./FieldBoolTranslator.vue?vue&type=script&lang=js&"
export * from "./FieldBoolTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports